import { formatDate } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { BaseDataTableFilter } from '../../../../../shared/components/data-table/filters/components/data-table-filter/BaseDataTableFilter';
import { DataTableFilterMessageService } from '../../../../../shared/components/data-table/filters/components/data-table-filter-message-service';
import { ReservationFilterStateService } from '../../../services/reservation-filter-state.service';
import { ReservationMessageService } from '../../../services/reservation-message.service';

@Component({
  selector: 'app-reservation-filter-to-date',
  templateUrl: './reservation-filter-to-date.component.html',
  styleUrls: ['./reservation-filter-to-date.component.scss'],
  standalone: true,
  imports: [
    MatDatepicker,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    MatInputModule
  ]
})
export class ReservationFilterToDateComponent extends BaseDataTableFilter implements OnInit {

  @ViewChild('picker') datePicker!: MatDatepicker<Date>;

  constructor(
    private filterMessageService: DataTableFilterMessageService,
    private reservationFilterStateService: ReservationFilterStateService,
    private reservationMessageService: ReservationMessageService
  ) {
    super(filterMessageService);
  }

  ngOnInit(): void {
    if (this.reservationFilterStateService.departureDate !== '') {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  datePickerOpened() {
    this.filterMessageService.setClickoutEnabled(false);
  }

  datePickerClosed() {
    this.filterMessageService.setClickoutEnabled(true);
  }

  onApplyClicked(): void {
    this.reservationMessageService.applyFilter();
    
    if (this.reservationFilterStateService.departureDate === '') {
      this.filterMessageService.setActive({ filterId: this.id, active: false });
    } else {
      this.filterMessageService.setActive({ filterId: this.id, active: true, value: this.getFilterStatusText() });
    }
  }

  onClearClicked(): void {
    this.reservationFilterStateService.resetDepartureDateFilter();
    this.reservationMessageService.applyFilter();
    this.filterMessageService.setActive({ filterId: this.id, active: false });
  }

  getFilterStateService(): ReservationFilterStateService {
    return this.reservationFilterStateService;
  }

  private getFilterStatusText(): string {
    return formatDate(this.reservationFilterStateService.departureDate,'MMM d, y', 'en-US', 'UTC');
  }
}